import { useState, useRef, useEffect } from 'react';
import { useTranslation } from '~/lib/hooks/useTranslation';
import { classNames } from '~/utils/classNames';

const languages = [
  { code: 'en', name: 'English', displayName: 'EN  English' },
  { code: 'pt', name: 'Português', displayName: 'PT  Português' },
  { code: 'tr', name: 'Türkçe', displayName: 'TR  Türkçe' },
];

export function LanguageSwitcher() {
  const { currentLanguage, changeLanguage } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (langCode: string) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={classNames(
          'flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-200',
          'text-white/80 hover:text-white hover:bg-white/10',
          'bg-black/20 backdrop-blur-sm border border-white/10 hover:border-white/20'
        )}
        aria-label="Change language"
      >
        <div className="i-ph:globe w-4 h-4" />
        <span className="text-sm font-medium">{currentLang.code.toUpperCase()}</span>
      </button>

      {isOpen && (
        <div className="absolute bottom-full left-0 mb-2 w-48 bg-[#2a2a2a] border border-white/10 rounded-2xl shadow-xl z-50 overflow-hidden">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={classNames(
                'w-full flex items-center justify-between px-4 py-3 text-left transition-colors',
                'hover:bg-white/5',
                currentLanguage === lang.code
                  ? 'bg-white/5 text-white'
                  : 'text-white/80 hover:text-white'
              )}
            >
              <span className="text-sm font-medium">{lang.displayName}</span>
              {currentLanguage === lang.code && (
                <div className="i-ph:check-bold w-4 h-4 text-white" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
